// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import logo from '../../images/common/quickmd-main-logo.png'
import './ErrorPage.scss'
import { setAppError } from '../../store/error-page/ErrorPageActions'

export const ErrorPage = () => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.error.error)
  const dispatch = useDispatch()
  const [lastError, setLastError] = useState('')
  useEffect(() => {
    if (error) {
      setLastError(error)
      setTimeout(() => {
        dispatch(setAppError(''))
      }, 1000)
    }
  }, [error])
  return (
    <div className='error-page-container'>
      <img src={logo} alt='Logo' className='error-page-logo' />
      <span className='error-page-label'>{lastError}</span>
    </div>
  )
}
